export function checkIsAudioPresentInVideo({ videoRef, defaultAudioStatus = true }) {
  if (!videoRef) return defaultAudioStatus;

  const hasAudio =
    videoRef.mozHasAudio || // Firefox
    !!videoRef.webkitAudioDecodedByteCount || // Chrome (some versions)
    !!videoRef.audioTracks?.length; // standard (not properly supported in chrome)

  return hasAudio;
}
